import { getLocalizedValue, getLocalizedAttrValue, getFrontImage } from '@grandvisionhq/utils';
import { getActiveVariant, getProductTitle as getProductTitle$1 } from '../helpers.js';

function getProductSeoInfo(locale, product, productTypeLabel, sku) {
    if (!(product === null || product === void 0 ? void 0 : product.masterVariant)) {
        return {};
    }
    const activeVariant = getActiveVariant(product, sku);
    const productTitle = getProductTitle(activeVariant, product, locale);
    const title = productTypeLabel ? productTypeLabel.concat(' ', productTitle) : productTitle;
    const description = getProductDescription(product, activeVariant, locale);
    const imageUrl = getProductImageUrl(activeVariant);
    return {
        title,
        description,
        imageUrl
    };
}
function getProductTitle(variant, product, locale) {
    var ref, ref1;
    if (variant.metaTitle) {
        return getLocalizedValue(variant.metaTitle, locale);
    } else if (product.metaTitle) {
        return getLocalizedValue(product.metaTitle, locale);
    }
    var ref2;
    const productType = (ref2 = (ref = product.productType) === null || ref === void 0 ? void 0 : (ref1 = ref.obj) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref2 !== void 0 ? ref2 : '';
    return getProductTitle$1(productType, product, variant, locale);
}
function getProductDescription(product, variant, locale) {
    if (variant.metaDescription) {
        return getLocalizedValue(variant.metaDescription, locale);
    } else if (product.metaDescription) {
        return getLocalizedValue(product.metaDescription, locale);
    }
    const description = getLocalizedAttrValue(variant, 'description', locale) || getLocalizedAttrValue(product.masterVariant, 'description', locale);
    return description;
}
function getProductImageUrl(variant) {
    var ref;
    const imageUrl = getFrontImage((ref = variant.media) === null || ref === void 0 ? void 0 : ref.images).url;
    return `${imageUrl}?q=70&w=1200&h=630&fit=fill&fm=jpeg`;
}

export { getProductSeoInfo };
//# sourceMappingURL=get-product-seo-info.js.map
